import { Component, input, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-workflow-card',
  templateUrl: './workflow-card.component.html',
  styleUrl: './workflow-card.component.scss',
  standalone: false
})
export class WorkflowCardComponent implements OnChanges {
  @Input() imgUrl: string;
  @Input() cornerIcon: string;
  @Input() color: string;
  @Input() title: string;
  @Input() text: string;
  @Input() isDynamic: boolean = false;
  secondColor: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['color']){
      this.secondColor = this.lightenHexColor(this.color, 20, 0.93);
    }
  }

  lightenHexColor(hex: string, percent: number, alpha: number): string {
    hex = hex.replace(/^#/, '');

    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    r = Math.min(255, Math.floor(r + (255 - r) * percent / 100));
    g = Math.min(255, Math.floor(g + (255 - g) * percent / 100));
    b = Math.min(255, Math.floor(b + (255 - b) * percent / 100));

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

}
